<template>
  <el-dialog style="text-align: left" :title="config.Title" :visible="true" :width="dialogWidth" :before-close="handleClose" :close-on-click-modal="false">
    <div slot="title"><div></div></div>
    <mx-page type="Home" theme="Panel" :selected="selected" :query="{ SelectedValue: config.Value, OnSelected: OnSelected }" :config="dialogConfig" :title="'选择' + config.Title" :name="'选择' + config.Title" />
    <div slot="footer" class="flex-row">
      <div style="padding-left: 30px" v-if="config.OnDelete">
        <el-button @click="handleDelete">删 除</el-button>
      </div>
      <div style="flex: 1"></div>
      <div>
        <span class="f14 b2 m02">已选中{{ this.selected.length }}个</span>
        <el-button type="primary" @click="handleOk">确认选择</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: { config: Object },
  data() {
    return { selected: [] }
  },
  computed: {
    dialogConfig() {
      return Object.assign({}, this.config.Config, { SelectedValue: this.config.Value, Selected: true })
    },
    dialogWidth() {
      return '1200px'
    }
  },
  methods: {
    OnSelected(data) {
      this.selected = data
    },
    handleOk() {
      this.config.Success && this.config.Success(this.selected)
      this.$matrix.CloseSelectionDialog()
    },
    handleClose() {
      this.$matrix.CloseSelectionDialog()
    }
  }
}
</script>
